import React from 'react';
import { Form, InputNumber } from 'antd';

import * as recurrence from '../../../../constants/recurrence-constants';
import { getRequired } from '../../../../helpers/reccurence-helper';

const IntervalItem = ({ onChange, selectedChoice, choiceLineValue, requiredItems, isRadioGroup }) => {
  return (
    <Form.Item
      wrapperCol={{ span: 24 }}
      rules={[
        {
          required: getRequired(isRadioGroup, selectedChoice, choiceLineValue, requiredItems),
          message: 'Required',
        },
      ]}
      name={['rules', 'interval']}
    >
      <InputNumber
        disabled={isRadioGroup && selectedChoice !== choiceLineValue}
        onChange={onChange}
        placeholder="Set a interval"
        min={1}
        style={{ width: '100%' }}
      />
    </Form.Item>
  );
};
export default IntervalItem;
